import React from "react";
import {
  Button, Card, CardHeader, CardBody, FormGroup, Form,
  Input, InputGroupText, InputGroup, Container, Row, Col
} from "reactstrap";
import AuthHeader from "@/components/Headers/AuthHeader";
import { ToastContainer } from "react-toastify";
import classnames from "classnames";

export type LoginViewProps = {
  email: string;
  password: string;
  focusedEmail: boolean;
  focusedPassword: boolean;
  setFocusedEmail: (focused: boolean) => void;
  setFocusedPassword: (focused: boolean) => void;
  onChange: React.ChangeEventHandler<HTMLInputElement>;
  onSubmit: React.FormEventHandler<HTMLFormElement>;
};


const LoginView = ({
  email,
  password,
  focusedEmail,
  focusedPassword,
  setFocusedEmail,
  setFocusedPassword,
  onChange,
  onSubmit,
}: LoginViewProps) => (
  <>
    <div className="rna-wrapper">
      <ToastContainer />
    </div>
    <AuthHeader
      title="Welcome!"
      lead="Use these awesome forms to login or create new account in your project for free."
    />
    <Container className="mt--8 pb-5">
      <Row className="justify-content-center">
        <Col lg="5" md="7">
          <Card className="bg-secondary border-0 mb-0">
            <CardHeader className="bg-transparent pb-3">
              <div className="btn-wrapper text-center">
                <h3 className="heading-title text-info mb-0">
                  Sign in with credentials
                </h3>
              </div>
            </CardHeader>
            <CardBody className="px-lg-5 py-lg-5">
              <Form role="form" onSubmit={onSubmit}>
                <FormGroup className={classnames("mb-3", { focused: focusedEmail })}>
                  <InputGroup className="input-group-merge input-group-alternative">
                    <InputGroupText><i className="ni ni-email-83" /></InputGroupText>
                    <Input
                      placeholder="Email"
                      type="text"
                      name="email"
                      value={email}
                      onFocus={() => setFocusedEmail(true)}
                      onBlur={() => setFocusedEmail(false)}
                      onChange={onChange}
                    />
                  </InputGroup>
                </FormGroup>
                <FormGroup className={classnames({ focused: focusedPassword })}>
                  <InputGroup className="input-group-merge input-group-alternative">
                    <InputGroupText><i className="ni ni-lock-circle-open" /></InputGroupText>
                    <Input
                      placeholder="Password"
                      type="password"
                      name="password"
                      value={password}
                      onFocus={() => setFocusedPassword(true)}
                      onBlur={() => setFocusedPassword(false)}
                      onChange={onChange}
                    />
                  </InputGroup>
                </FormGroup>
                <div className="custom-control custom-control-alternative custom-checkbox">
                  <input className="custom-control-input" id="customCheckLogin" type="checkbox" />
                  <label className="custom-control-label" htmlFor="customCheckLogin">
                    <span className="text-muted">Remember me</span>
                  </label>
                </div>
                <div className="text-center">
                  <Button className="my-4" color="info" type="submit">Sign in</Button>
                </div>
              </Form>
            </CardBody>
          </Card>
          <Row className="mt-3">
            <Col xs="6">
              <a className="text-light" href="#pablo" onClick={(e) => e.preventDefault()}>
                <small>Forgot password?</small>
              </a>
            </Col>
          </Row>
        </Col>
      </Row>
    </Container>
  </>
);

export default LoginView;

